import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bbff8e62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-footer lo-g-gutter--half" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-footer__content" }, [
  /*#__PURE__*/_createElementVNode("div", null, " Alliance Genève Sàrl "),
  /*#__PURE__*/_createElementVNode("div", null, " Rue des Alpes 15 – 1201 Genève "),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:nicolas@commergnat.com?subject=Contact%20depuis%20le%20site%20commergnat.com" }, "nicolas@commergnat.com")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " © 2022 tous droits réservés. ")
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}